import NiceModal from "@ebay/nice-modal-react";
import P from "components/P";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import ModalBase from "modals/base/ModalBase";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { createRef, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { decode, encode } from "shared/utils/Utils";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import CheckBox from "components/inputs/checkBox/CheckBox";
import AdminCustomButton, { style } from "components/buttons/AdminCustomButton";
import QuillEditor from "components/inputs/richEditor/QuillEditor";
import InputText from "components/inputs/InputText";
import DatePicker from "components/inputs/datePicker/DatePicker";
import { adminRequester } from "App";
import { useNavigate } from "react-router-dom";
import { isDefaultBoardName } from "./BoardDetailModal";
import _ from "lodash";
import AdminInputImage from "components/inputs/image/AdminInputImage";
import AdminImage from "components/Image/AdminImage";

const ArticleDetailModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  // const { isMobile } = useContext(BrowserDetectContext);
  const [mounted, setMounted] = useState(false);
  const { data, onSuccess, editable = true } = props;
  const inputs = useRef([]);
  const [withHeader, withFooter] = [true, false];
  const [width, height] = ["min(95%, 1280px)", "80vh"];
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const modal = useRef();
  const [edit, setEdit] = useState(false);
  const [decodeContent, setDecodeContent] = useState();
  const [hidden, setHidden] = useState(data?.hidden);
  const [startDate, setStartDate] = useState(
    data?.start_date ? new Date(data?.start_date) : null
  );
  const [boards, setBoards] = useState([]);
  const [board, setBoard] = useState(data?.board?.id);
  const [regions, setRegions] = useState([]);
  const [region, setRegion] = useState(data?.board?.region_id);
  const [stores, setStores] = useState([]);
  const [store, setStore] = useState(data?.board?.store_id);
  const [all, setAll] = useState(data?.board?.region_id ? false : true);
  const [endDate, setEndDate] = useState(
    data?.end_date ? new Date(data?.end_date) : null
  );
  const [order, setOrder] = useState();
  const [item, setItem] = useState(data?.variant_id);
  const navigate = useNavigate();
  useEffect(() => setMounted(true), []);
  useEffect(() => {
    if (isBase64(data.content)) {
      let loadedHtml = decode(data.content);
      setDecodeContent(loadedHtml);
    } else setDecodeContent(data.content);
  }, [data]);
  useEffect(() => {
    if (mounted) {
      adminRequester.getRegions((result) => setRegions(result.regions));
      adminRequester.getStores({}, (result) => setStores(result.stores));
    }
  }, [mounted]);
  useEffect(() => {
    if (mounted && data) {
      adminRequester.getBoards(
        all
          ? { region_id: null, store_id: null }
          : {
              region_id: region,
              store_id: store,
            },
        (result) => setBoards(result.boards)
      );
      if (data?.order_id)
        adminRequester.getOrder(data?.order_id, {}, (result) =>
          setOrder(result.order)
        );
    }
  }, [mounted, data, all, region, store]);
  const CheckBox = ({ disabled, onChange, checked }) => {
    return (
      <FlexChild width="50px" flex justifyContent="center" alignItems="center">
        <div style={{ padding: "5px" }}>
          <input
            disabled={disabled}
            type="checkbox"
            style={{ display: "block", zoom: "1.5" }}
            onChange={onChange}
            checked={checked}
          />
        </div>
      </FlexChild>
    );
  };
  function isBase64(str) {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  }

  const openOrder = () => {
    NiceModal.show("adminCheckSelect", {
      request: async (...props) => adminRequester.getOrders(...props),
      code: "orders",
      title: "주문서 목록",
      multiple: false,
      limit: 10,
      extraCondition: all
        ? { expand: "items.variant.product,customer" }
        : {
            expand: "items.variant.product,customer",
            region_id: region,
            store_id: store,
          },
      headers: [
        { code: "id", label: "주문ID" },
        {
          code: "customer",
          Cell: ({ cell }) =>
            `${cell.first_name}${cell?.last_name ? ` ${cell.last_name}` : ""}`,
        },
        {
          code: "items",
          Cell: ({ row, cell }) => (
            <VerticalFlex key={row.id}>
              {cell?.map((item, index) => (
                <HorizontalFlex>
                  <FlexChild key={item?.id}>
                    <Inline>
                      <P>({index + 1}) </P>
                      <P>{item?.variant?.product?.title}</P>
                      <P> / </P>
                      <P>{item.variant.title}</P>
                    </Inline>
                  </FlexChild>
                </HorizontalFlex>
              ))}
            </VerticalFlex>
          ),
        },
      ],
      onSelect: (result) => setOrder(result[0]),
      Search: ({ callback }) => (
        <input
          type="text"
          onKeyDown={(e) => {
            if (e.key === "Enter") callback({ t: e.target.value });
          }}
          style={{
            outline: "none",
            backgroundColor: "rgb(233, 233, 233)",
            borderRadius: "10px",
            marginLeft: "auto",
            paddingRight: "10px",
            paddingLeft: "10px",
            minWidth: "250px",
          }}
          placeholder="search..."
        />
      ),
    });
  };
  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      title={"게시물 상세"}
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
    >
      <PaddingWrapper padding={30}>
        <div style={{ height: "70vh", overflowY: "auto" }}>
          <VerticalFlex gap={20}>
            {edit && !data.order_id && !data.variant_id && (
              <FlexChild>
                <HorizontalFlex>
                  <FlexChild>
                    <HorizontalFlex gap={20}>
                      <FlexChild width={"20%"}>
                        <P weight={"bold"}>스토어</P>
                      </FlexChild>
                      <FlexChild>
                        <select
                          value={store}
                          disabled={all}
                          onChange={(e) => setStore(e.target.value)}
                        >
                          {stores?.map((store) => (
                            <option key={store.id} value={store.id}>
                              {store.name}
                            </option>
                          ))}
                        </select>
                      </FlexChild>
                    </HorizontalFlex>
                  </FlexChild>
                  <FlexChild>
                    <HorizontalFlex gap={20}>
                      <FlexChild width={"20%"}>
                        <P weight={"bold"}>지역</P>
                      </FlexChild>
                      <FlexChild>
                        <select
                          value={region}
                          disabled={all}
                          onChange={(e) => setRegion(e.target.value)}
                        >
                          {regions?.map((region) => (
                            <option key={region.id} value={region.id}>
                              {region.name}
                            </option>
                          ))}
                        </select>
                      </FlexChild>
                    </HorizontalFlex>
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
            )}
            <FlexChild>
              <HorizontalFlex alignItems="flex-start">
                <FlexChild>
                  <HorizontalFlex gap={20}>
                    <FlexChild width={"20%"}>
                      <P weight={"bold"}>종류</P>
                    </FlexChild>
                    <FlexChild>
                      {edit && data.board?.name !== "review" ? (
                        <select
                          value={board}
                          onChange={(e) => setBoard(e.target.value)}
                        >
                          {boards
                            ?.filter((f) => f.name !== "review")
                            ?.map((board) => (
                              <option key={board.id} value={board.id}>
                                {isDefaultBoardName(board?.name)
                                  ? t(board.name)
                                  : board?.name}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <P size={15}>
                          {isDefaultBoardName(data?.board?.name)
                            ? t(data.board.name)
                            : data?.board?.name}
                        </P>
                      )}
                    </FlexChild>
                  </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                  {edit && data.board?.name !== "review" && (
                    <HorizontalFlex justifyContent="flex-start" gap={20}>
                      <FlexChild width={"20%"}>
                        <P weight={"bold"}>전체설정</P>
                      </FlexChild>
                      <FlexChild width="max-content">
                        <CheckBox checked={all} onChange={() => setAll(!all)} />
                      </FlexChild>
                    </HorizontalFlex>
                  )}
                  {data.board?.name === "review" && (
                    <VerticalFlex gap={10}>
                      {data?.order_id && (
                        <HorizontalFlex gap={20}>
                          <FlexChild width={"20%"}>
                            <P weight={"bold"}>주문서ID</P>
                          </FlexChild>
                          <FlexChild>
                            {edit ? (
                              <HorizontalFlex
                                gap={10}
                                justifyContent="flex-start"
                              >
                                <P size={15}>{order?.id}</P>
                                <AdminCustomButton
                                  text="주문서 목록"
                                  style={style.white_border}
                                  onClick={openOrder}
                                />
                              </HorizontalFlex>
                            ) : (
                              <P size={15}>{order?.id}</P>
                            )}
                          </FlexChild>
                        </HorizontalFlex>
                      )}
                      {data?.variant_id && (
                        <HorizontalFlex gap={20}>
                          <FlexChild width={"20%"}>
                            <P weight={"bold"}>상품</P>
                          </FlexChild>
                          <FlexChild>
                            {edit ? (
                              <select
                                value={item}
                                onChange={(e) => setItem(e.target.value)}
                              >
                                {order?.items?.map((item) => (
                                  <option key={item.id} value={item.variant.id}>
                                    {`${item?.variant?.product?.title} / ${item?.variant?.title}`}{" "}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <P
                                size={15}
                              >{`${data?.variant?.product?.title} / ${data?.variant?.title}`}</P>
                            )}
                          </FlexChild>
                        </HorizontalFlex>
                      )}
                    </VerticalFlex>
                  )}
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex justifyContent="flex-start">
                <HorizontalFlex gap={20}>
                  <FlexChild width={"20%"}>
                    <P weight={"bold"}>작성/수정일</P>
                  </FlexChild>
                  <FlexChild>
                    <Inline>
                      <P size={15}>
                        {new Date(
                          new Date(data.created_at).getTime() -
                            new Date().getTimezoneOffset() * 60 * 1000
                        )
                          .toISOString()
                          .replace("T", " ")
                          .slice(0, 16)}
                      </P>
                      <P> / </P>
                      <P size={15}>
                        {new Date(
                          new Date(data.updated_at).getTime() -
                            new Date().getTimezoneOffset() * 60 * 1000
                        )
                          .toISOString()
                          .replace("T", " ")
                          .slice(0, 16)}
                      </P>
                    </Inline>
                  </FlexChild>
                </HorizontalFlex>
                <HorizontalFlex gap={20}>
                  <FlexChild width={"20%"}>
                    <P weight={"bold"}>기간</P>
                  </FlexChild>
                  <FlexChild>
                    {edit ? (
                      <VerticalFlex
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        gap={5}
                      >
                        <AdminCustomButton
                          text="무제한"
                          selected={!startDate && !endDate}
                          onClick={() => {
                            setStartDate(null);
                            setEndDate(null);
                          }}
                        />
                        <DatePicker
                          maxDate={new Date("2999-12-31")}
                          type={"time"}
                          startDate={startDate}
                          endDate={endDate}
                          onChange={({ startDate, endDate }) => {
                            if (startDate) setStartDate(startDate);
                            if (endDate) setEndDate(endDate);
                          }}
                        />
                      </VerticalFlex>
                    ) : data.start_date || data.end_date ? (
                      <Inline>
                        <P>
                          {data.start_date
                            ? data.start_date.replace("T", " ").slice(0, 16)
                            : "null"}
                        </P>
                        <P> ~ </P>
                        <P>
                          {data.end_date
                            ? data.end_date.replace("T", " ").slice(0, 16)
                            : "null"}
                        </P>
                      </Inline>
                    ) : (
                      <P size={15}>무제한</P>
                    )}
                  </FlexChild>
                </HorizontalFlex>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex justifyContent="flex-start">
                <HorizontalFlex gap={20}>
                  <FlexChild width={"20%"}>
                    <P weight={"bold"}>작성자</P>
                  </FlexChild>
                  <FlexChild>
                    {data.user ? (
                      <Inline>
                        <P>[관리자] </P>
                        <P>{`${data.user?.first_name}${
                          data.user?.last_name ? ` ${data.user?.last_name}` : ""
                        }`}</P>
                      </Inline>
                    ) : data.customer ? (
                      <Inline>
                        <P>[고객] </P>
                        <P>{`${data.customer?.first_name}${
                          data.customer?.last_name
                            ? ` ${data.customer?.last_name}`
                            : ""
                        }`}</P>
                      </Inline>
                    ) : (
                      <P>-</P>
                    )}
                  </FlexChild>
                </HorizontalFlex>
                <HorizontalFlex gap={20}>
                  <FlexChild width={"20%"}>
                    <P weight={"bold"}>비밀글</P>
                  </FlexChild>
                  <FlexChild>
                    <CheckBox
                      disabled={!edit}
                      checked={hidden}
                      onChange={() => setHidden(!hidden)}
                    />
                  </FlexChild>
                </HorizontalFlex>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={20}>
                <FlexChild width={"10%"}>
                  <P weight={"bold"}>제목</P>
                </FlexChild>
                <FlexChild>
                  {/* <P size={15}>{data.title}</P> */}
                  <InputText
                    value={data.title}
                    readOnly={!edit}
                    validable={false}
                    ref={(el) => (inputs.current[0] = el)}
                  />
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            {data.board?.name === "banner" && (
              <FlexChild>
                <HorizontalFlex gap={20}>
                  <FlexChild width={"10%"}>
                    <P weight={"bold"}>링크</P>
                  </FlexChild>
                  <FlexChild>
                    {edit ? (
                      <InputText
                        value={data.metadata?.link}
                        readOnly={!edit}
                        validable={false}
                        ref={(el) => (inputs.current[2] = el)}
                      />
                    ) : (
                      <a
                        href={data.metadata?.link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {data.metadata?.link}
                      </a>
                    )}
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
            )}
            {data.board?.name === "banner" && (
              <FlexChild>
                <HorizontalFlex gap={20}>
                  <FlexChild width={"10%"}>
                    <P>배너이미지</P>
                  </FlexChild>
                  <FlexChild>
                    {edit ? (
                      <AdminInputImage
                        ref={(el) => (inputs.current[3] = el)}
                        name={"배너"}
                        path={"/article/banner"}
                        labelWidth={0}
                        cropWidth={1300}
                        cropHeight={520}
                        maxSizeMb={4}
                        value={data?.metadata?.banner}
                      />
                    ) : (
                      <AdminImage
                        width={650}
                        height={260}
                        src={data?.metadata?.banner}
                      />
                    )}
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
            )}
            <FlexChild height={edit ? "43vh" : "47vh"}>
              <HorizontalFlex gap={20} alignItems="flex-start">
                <FlexChild width={"10%"}>
                  <P weight={"bold"}>내용</P>
                </FlexChild>
                <FlexChild height={edit ? "40vh" : "47vh"}>
                  {edit ? (
                    <QuillEditor
                      ref={(el) => (inputs.current[1] = el)}
                      name={"내용"}
                      value={decodeContent && encode(decodeContent)}
                      path={"article/" + data.id}
                      style={{ padding: 5 }}
                      height="42vh"
                    />
                  ) : (
                    <QuillViewer
                      style={{ border: "1px solid gray", padding: 5 }}
                      value={decodeContent && decodeContent}
                    />
                  )}
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex justifyContent="center" gap={15}>
                {edit ? (
                  <FlexChild width="max-content">
                    <AdminCustomButton
                      text="저장"
                      style={style.white_border}
                      onClick={() => {
                        inputs.current[1].isValid().then(() => {
                          const update = {};
                          update.board_id = board;
                          update.start_date = startDate;
                          update.end_date = endDate;
                          update.hidden = hidden;
                          update.title = inputs.current[0].getValue();
                          update.content = inputs.current[1].getValue();

                          if (order) update.order_id = order;
                          if (item) update.variant_id = item;
                          if (data?.board.name === "banner") {
                            inputs?.current[3].isValid().then(() => {
                              update.metadata = _.merge(data.metadata, {
                                link: inputs?.current?.[2]?.getValue(),
                                banner: inputs.current[3].getValue(),
                              });
                              adminRequester.updateArticle(
                                data.id,
                                update,
                                () => {
                                  modal.current.close();
                                  onSuccess?.();
                                }
                              );
                            });
                          } else
                            adminRequester.updateArticle(
                              data.id,
                              update,
                              () => {
                                modal.current.close();
                                onSuccess?.();
                              }
                            );
                        });
                      }}
                    />
                  </FlexChild>
                ) : editable ? (
                  <FlexChild width="max-content">
                    <AdminCustomButton
                      text="편집"
                      style={style.white_border}
                      onClick={() => setEdit(true)}
                    />
                  </FlexChild>
                ) : (
                  <FlexChild width="max-content">
                    <AdminCustomButton
                      text="상세"
                      style={style.white_border}
                      onClick={() => {
                        navigate(`/article/${data.id}`);
                        modal.current.close();
                      }}
                      onMouseDown={(e) => {
                        if (e.button === 1) {
                          window.open(
                            `${window.location.origin}/article/${data.id}`,
                            "_blank"
                          );
                          modal.current.close();
                        }
                      }}
                    />
                  </FlexChild>
                )}
                {edit ? (
                  <FlexChild width="max-content">
                    <AdminCustomButton
                      style={style.white_border}
                      text="취소"
                      onClick={() => {
                        setStartDate(
                          data.start_date ? new Date(data.start_date) : null
                        );
                        setEndDate(
                          data.end_date ? new Date(data.end_date) : null
                        );
                        inputs.current[0].setValue(data.title);
                        inputs.current[1].setValue(
                          decodeContent && encode(decodeContent)
                        );
                        setRegion(data?.board?.region_id);
                        setStore(data?.board?.store_id);
                        setAll(data?.board?.region_id ? false : true);
                        setHidden(data.hidden);
                        setEdit(false);
                      }}
                    />
                  </FlexChild>
                ) : (
                  <FlexChild width="max-content">
                    <AdminCustomButton
                      style={style.white_border}
                      text="닫기"
                      onClick={() => modal.current.close()}
                    />
                  </FlexChild>
                )}
              </HorizontalFlex>
            </FlexChild>
          </VerticalFlex>
        </div>
      </PaddingWrapper>
    </ModalBase>
  );
});

export default ArticleDetailModal;
